export enum FollowTab {
  following = "following",
  followers = "followers",
}
